<template>
  <aside class="lm-menu">
    <ul class="user-menu">
      <li
        v-for="(item, index) in menuItems"
        :key="index"
      >
        <template v-if="item.parent">
          <span
            class="menu-item"
            :class="{ 'menu-item-collapsed': !expanded }"
            @click="$emit('expand')"
            v-b-popover="popoverProps(item)"
            v-b-toggle="`menu-child-${index}`"
          >
            <i :class="item.icon"></i>
            <span :class="{ 'd-none': !expanded }">{{ item.name }}</span>
          </span>
          <b-collapse
            v-if="expanded"
            tag="ul"
            class="menu-children"
            :id="`menu-child-${index}`"
          >
            <router-link
              v-for="child in item.childs"
              :key="child.id"
              :to="child.path"
              class="sub-menu-item"
            >
              <i :class="child.icon"></i>
              {{ child.name  }}
            </router-link>
          </b-collapse>
        </template>

        <router-link
          v-else
          class="menu-item"
          :class="{ 'menu-item-collapsed': !expanded }"
          :to="item.path"
          v-b-popover="popoverProps(item)"
        >
          <i :class="item.icon"></i>
          <span :class="{ 'd-none': !expanded }">{{ item.name  }}</span>
        </router-link>
      </li>
    </ul>

    <div class="settings-menu" v-if="settingsItem">
      <b-dropdown
        variant="link"
        toggle-class="settings-button-dropdown"
        menu-class="settings-menu-dropdown"
        no-caret
        dropright
      >

        <template #button-content>
          <span
            class="menu-item"
            :class="{ 'menu-item-collapsed': !expanded }"
            v-b-popover="popoverProps(settingsItem)"
          >
            <i :class="settingsItem.icon"></i>
            <span :class="{ 'd-none': !expanded }">{{ settingsItem.name }}</span>
          </span>
        </template>

        <b-dropdown-item
          v-for="(item, index) in settingsItem.childs"
          :key="index"
          :to="item.path"
          exact-active-class="active"
        >
          <span>
            <i :class="item.icon"></i>
            {{ item.name }}
          </span>
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </aside>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    expanded: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters('settings', [
      'menuItems',
      'settingsItem'
    ])
  },
  methods: {
    popoverProps (item) {
      return {
        content: item.name,
        placement: 'right',
        customClass: 'ml-3',
        disabled: this.expanded,
        trigger: 'hover',
        boundary: 'viewport'
      }
    }
  },
  watch: {
    expanded (val) {
      if (val) {
        this.$root.$emit('bv::hide::popover')
      }
    }
  }
}
</script>

<style lang="sass">
.lm-menu
  font-size: .9rem
  color: white
  width: 100%
  height: calc(100vh - 70px)
  display: flex
  flex-direction: column
  justify-content: space-between
  background-color: var(--app-accent-color)

.user-menu
  margin: .5rem 0
  padding: .5rem 0
  overflow-y: auto
  &::-webkit-scrollbar
    width: 8px
  &::-webkit-scrollbar-track
    background: transparent
  &::-webkit-scrollbar-thumb
    border-radius: 20px
    background: #888
  &::-webkit-scrollbar-thumb:hover
    background: #555

  .menu-children
    margin-left: 1rem
    border-left: 3px solid rgba(237, 237, 237, .6)

.settings-menu
  border-top: 1px solid white
  > .dropdown
    width: 100%
    > .settings-menu-dropdown
      max-height: 80vh
      padding: .5rem .5rem
      background-color: var(--app-accent-color)
      overflow-y: auto
      &::-webkit-scrollbar
        width: 8px
      &::-webkit-scrollbar-track
        background: var(--app-accent-color)
      &::-webkit-scrollbar-thumb
        border-radius: 20px
        background: #888
      &::-webkit-scrollbar-thumb:hover
        background: #555

      > li > .dropdown-item
        font-size: .9rem
        color: white
        margin: .6rem 0
        padding: .6rem 1rem
        border-radius: 8px
        &.active
          background-color: rgba(0, 75, 150, 0.9)
        &:hover, &:focus
          background-color: rgba(0, 75, 150, 0.9)
        > span
          color: white
          gap: 15px
          display: flex
    > .settings-button-dropdown
      width: 100%
      padding: 0px
      &:hover, &:focus
        box-shadow: none

.menu-item
  color: white
  margin: .6rem
  padding: .6rem 1rem
  display: flex
  align-items: center
  border-radius: 8px
  cursor: pointer
  gap: 15px
  &.menu-item-collapsed
    justify-content: center
  &.router-link-exact-active
    background-color: rgba(0, 75, 150, 0.9)
  &:hover
    color: white
    background-color: rgba(0, 75, 150, 0.9)

.sub-menu-item
  color: white
  margin: 0 .6rem
  padding: .6rem 1rem
  display: flex
  align-items: center
  border-radius: 8px
  cursor: pointer
  gap: 15px
  &.router-link-exact-active
    color: white
  &:hover, &.router-link-exact-active
    color: white
    background-color: rgba(0, 75, 150, 0.9)
</style>
